export default __webpack_public_path__ + "static/media/change_management.e5f81173.png";